export default {
  pageTitle: {
    index: '{title}',
    report: "{title}'s Report",
    create: 'Create {title}',
    edit: 'Edit {title} - {id}',
    detail: "{title}'s Detail - {id}"
  }
}
